export default __webpack_public_path__ + "static/media/feedback3-TYG.25b8edf1.png";